const UNICORNSPRINGS_INTENT_SIGNUP = 'signup';
const SSO_TAG_UNICORNSPRINGS_PORTAL = 'unicornsprings-portal';

export {
    UNICORNSPRINGS_INTENT_SIGNUP,
    SSO_TAG_UNICORNSPRINGS_PORTAL,
};
